import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import navigationService from '@/services/NavigationService';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  setup(__props) {

const { t } = useI18n();
const routes = ref<string[]>([]);

onMounted(() => {
  routes.value = navigationService.getHistory();
});

function goBack() {
  navigationService.goBack();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (routes.value.length === 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)(`routes.${routes.value[0]}`)), 1))
      : (routes.value.length === 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createElementVNode("a", { onClick: goBack }, _toDisplayString(_unref(t)(`routes.${routes.value[0]}`)), 1),
            _cache[0] || (_cache[0] = _createTextVNode(" > ")),
            _createElementVNode("span", null, _toDisplayString(_unref(t)(`routes.${routes.value[1]}`)), 1)
          ]))
        : (routes.value.length > 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "... > ", -1)),
              _createElementVNode("a", { onClick: goBack }, _toDisplayString(_unref(t)(`routes.${routes.value[routes.value.length - 2]}`)), 1),
              _cache[2] || (_cache[2] = _createTextVNode(" > ")),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(`routes.${routes.value[routes.value.length - 1]}`)), 1)
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})